const USER_ROLES = {
  USER: 'USER',
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
};

const roleHierarchy = {
  [USER_ROLES.USER]: [
    USER_ROLES.ADMIN,
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.USER,
  ],
  [USER_ROLES.ADMIN]: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
  [USER_ROLES.SUPER_ADMIN]: [USER_ROLES.SUPER_ADMIN],
};

const checkRole = (currentRole, excludeRoleHierarchy = false, rolesToCheck) => {
  // Si aucun rôle à vérifier n'est fourni, retourner false
  if (!rolesToCheck) return false;

  const safeRequiredRoles = Array.isArray(rolesToCheck)
    ? rolesToCheck
    : [rolesToCheck];

  if (excludeRoleHierarchy) return safeRequiredRoles.includes(currentRole);

  return safeRequiredRoles.some(
    (requiredRole) =>
      // Vérifier si requiredRole existe dans roleHierarchy avant d'appeler .includes()
      roleHierarchy[requiredRole] &&
      roleHierarchy[requiredRole].includes(currentRole)
  );
};

export { checkRole };
export default USER_ROLES;
